module.exports = __webpack_public_path__ + "mainassets/img/anim_01_570x570.567d2f3b.webp";